import { render, staticRenderFns } from "./blogtypeTax.vue?vue&type=template&id=ddb07e62"
import script from "./blogtypeTax.vue?vue&type=script&lang=js"
export * from "./blogtypeTax.vue?vue&type=script&lang=js"
import style0 from "./blogtypeTax.vue?vue&type=style&index=0&id=ddb07e62&prod&lang=css"
import style1 from "./blogtypeTax.vue?vue&type=style&index=1&id=ddb07e62&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports